import {Object3D} from 'three'
import {BaseLoader} from './BaseLoader'
import {ONSALE_CONSTANTS} from '@/components/MapContext/ThreeJs/DataOfThreeJS/OnSaleLoader/OnSaleConstants'
import {Font} from 'three/examples/jsm/loaders/FontLoader.js'
import {createTextMesh} from './utils/createTextMesh'

export default class onSaleLoaderReOnSaleLoader extends BaseLoader {
  private onSaleModel: Object3D | null = null
  private objectCounter = 0
  private fontRef: React.RefObject<Font | null> | null = null

  setFontRef(fontRef: React.RefObject<Font | null>): void {
    this.fontRef = fontRef
    this.createSaleModel()
  }

  async waitForLoad(): Promise<void> {
    return Promise.resolve()
  }

  private createSaleModel(): void {
    if (!this.fontRef || !this.fontRef.current) {
      return
    }

    const mesh = createTextMesh({
      text: 'SALE',
      font: this.fontRef.current,
      color: 0xff0000,
    })

    mesh.scale.set(
      ONSALE_CONSTANTS.MODEL_SCALE,
      ONSALE_CONSTANTS.MODEL_SCALE,
      ONSALE_CONSTANTS.MODEL_SCALE
    )

    this.onSaleModel = mesh
  }

  clearAllOnSaleObjects(): void {
    this.clearAll()
  }

  protected onAfterClear(): void {
    this.objectCounter = 0
  }

  get onSaleObjects(): Readonly<Record<string, Object3D>> {
    const result: Record<string, Object3D> = {}
    this.objectsMap.forEach((obj, id) => {
      if (id.startsWith(ONSALE_CONSTANTS.OBJECT_ID_PREFIX)) {
        const key = id.replace(ONSALE_CONSTANTS.OBJECT_ID_PREFIX, '')
        result[key] = obj
      }
    })
    return Object.freeze(result) as Readonly<Record<string, Object3D>>
  }

  removeOnSaleObject(object: Object3D): void {
    if (!this.hasThreeLayer()) return

    this.objectsMap.forEach((obj, id) => {
      if (obj === object) {
        this.threeLayer.removeObject(id)
        this.removeObjectFromCollection(id)
      }
    })
  }

  addOnSaleObject(center: [number, number]): Object3D | null {
    if (!this.onSaleModel || !this.hasThreeLayer()) return null

    const object = this.onSaleModel.clone()
    object.position.y = ONSALE_CONSTANTS.OBJECT_POSITION_Y
    object.rotation.set(0, 0, 0)

    const objectId = this.objectCounter++
    const id = `${ONSALE_CONSTANTS.OBJECT_ID_PREFIX}${objectId}`
    const group = this.threeLayer.addObject(
      id,
      object,
      center,
      ONSALE_CONSTANTS.OBJECT_ALTITUDE,
      ONSALE_CONSTANTS.OBJECT_SCALE
    )

    group.name = id
    this.addObjectToCollection(id, group)

    return group
  }
}
